import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4001Model } from './kymw4001.model';
import { KYMW4002Component } from '../../kymw40/kymw4002/kymw4002.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { GetPromotionListService } from './api-services/get-promotion-list.service';
import { OutputPromotionListService } from './api-services/output-promotion-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW4002InputModel } from '../kymw4002/vo/kymw4002-input.model';
import { Menu } from '@grapecity/wijmo.input';
import { EventArgs } from '@grapecity/wijmo';

/**
 * プロモーションマスタ一覧画面を管理するクラス
 *
 * @export KYMW4001Component
 * @class KYMW4001Component
 */
@Component({
  selector: 'app-kymw4001',
  templateUrl: 'kymw4001.component.html',
  styleUrls: ['kymw4001.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4001Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_PromotionList', { static: true }) dtg_PromotionList: FlexGrid;

  // 親画面からの連携値
  param: any;

  kymw4001Model: KYMW4001Model = new KYMW4001Model();

  // コンテキストメニュー
  private contextMenu: Menu;

  /**
   * Creates an instance of KYMW4001Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {GetPromotionListService} getPromotionListService
   * @param {OutputPromotionListService} outputPromotionListService
   * @memberof KYMW4001Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getPromotionListService: GetPromotionListService,
    private outputPromotionListService: OutputPromotionListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW4001Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4001';

    // コンテキストメニュー初期化処理
    this.setContextMenu();

    // 週次プロモーションマスタ一覧取得API呼び出し
    this.getPromotionListService.execute(this.kymw4001Model,
      (data: any) => this.getPromotionListServiceServiceSuccessFunc(data));
      
    // グリッドの初期選択行はなしとする
    this.dtg_PromotionList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_PromotionList.select(-1, -1);
    });
  }

  /**
   * 出力ボタンを押下した時に呼び出される
   *
   * @memberof KYMW4001Component
   */
  public eventOutput_CLICKHandler(): void {
    // 週次プロモーションマスタ一覧出力API呼び出し
    this.outputPromotionListService.execute(this.kymw4001Model,
      (data: any) => this.outputPromotionListServiceServiceSuccessFunc(data));
  }

  /**
   * 登録ボタンを押下した時に呼び出される
   *
   * @memberof KYMW4001Component
   */
  public eventPromotion_CLICKHandler(): void {
    // プロモーションマスタメンテナンス画面InputVO初期化処理
    const kymw4002InputVO: KYMW4002InputModel = new KYMW4002InputModel();
    kymw4002InputVO.mode = 0;                                                   // 起動モード(0：登録)

    const componentRef = this.dialogService.openModal(KYMW4002Component);
    const instance = componentRef.componentInstance as KYMW4002Component;
    instance.setInterfaceParam(kymw4002InputVO);
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();

      // 週次プロモーションマスタ一覧取得API呼び出し
      this.getPromotionListService.execute(this.kymw4001Model,
        (data: any) => this.getPromotionListServiceServiceSuccessFunc(data));
    };
  }

  /**
   * コンテキストメニュー選択時に呼び出される
   *
   * @memberof KYMW4001Component
   */
  public eventMaintenance_CLICKHandler(): void {
    // プロモーションマスタメンテナンス画面InputVO初期化処理
    const kymw4002InputVO: KYMW4002InputModel = new KYMW4002InputModel();
    kymw4002InputVO.mode = 1;                                                   // 起動モード(1：更新)
    kymw4002InputVO.promotionNo = this.dtg_PromotionList.selectedItems[0].PromotionNo;
    kymw4002InputVO.promotionInfo = this.dtg_PromotionList.selectedItems[0].PromotionInfo;
    kymw4002InputVO.markCode1 = this.dtg_PromotionList.selectedItems[0].MarkCode1;
    kymw4002InputVO.markCode2 = this.dtg_PromotionList.selectedItems[0].MarkCode2;
    kymw4002InputVO.markCode3 = this.dtg_PromotionList.selectedItems[0].MarkCode3;
    kymw4002InputVO.markCode4 = this.dtg_PromotionList.selectedItems[0].MarkCode4;
    kymw4002InputVO.markCode5 = this.dtg_PromotionList.selectedItems[0].MarkCode5;
    kymw4002InputVO.multiPublishFlag = PlessViewUtilsSub.StringTOBoolean(this.dtg_PromotionList.selectedItems[0].MultiPublishFlag);

    const componentRef = this.dialogService.openModal(KYMW4002Component);
    const instance = componentRef.componentInstance as KYMW4002Component;
    instance.setInterfaceParam(kymw4002InputVO);
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();

      // 週次プロモーションマスタ一覧取得API呼び出し
      this.getPromotionListService.execute(this.kymw4001Model,
        (data: any) => this.getPromotionListServiceServiceSuccessFunc(data));
    };
  }

  /**
   * 週次プロモーションマスタ一覧取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW4001Component
   */
  public getPromotionListServiceServiceSuccessFunc(data: any) {
    // プロモーションマスタ一覧更新処理
    this.kymw4001Model.outputPromotionList(data);
  }

  /**
   * 週次プロモーションマスタ一覧出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW4001Component
   */
  public outputPromotionListServiceServiceSuccessFunc(data: any) {
    // ファイル名の設定
    const fileName = 'プロモーションマスタ一覧_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.tsv';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

  /**
   * コンテキストメニュー初期化
   *
   * @private
   * @memberof KYMW4001Component
   */
  private setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: 'プロモーションマスタメンテナンス', caption: 'プロモーションマスタメンテナンス',
            cmd: 'EditPromotion', enabled: true
          },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s: any, e: any) => {
          switch (this.contextMenu.selectedValue) {
            case 'EditPromotion':
              this.eventMaintenance_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_PromotionList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        // コンテキストメニューの活性非活性制御
        this.eventContextMenu_Handler();
        // メニュー表示
        this.contextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0], 'true');
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @returns {*}
   * @memberof KYMW4001Component
   */
  public getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * コンテキストメニューの活性非活性制御
   *
   * @private
   * @param {Menu} contextMenu
   * @memberof KYMW4001Component
   */
  public eventContextMenu_Handler(): void {
    this.contextMenu.itemsSource.forEach(contextMenuItem => {
      let enabledFlg = false;
      if (this.dtg_PromotionList.selection.row >= 0) {
        enabledFlg = true;
      }

      contextMenuItem.enabled = this.setContextMenuEnabled(contextMenuItem, enabledFlg);
    });
  }
}
